// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-text[data-v-3bd112fd] {\n  font-size: 18px;\n}", ""]);
// Exports
module.exports = exports;
